document.addEventListener("turbo:load", function () {
  const modal = document.getElementById("paymentModal");
  const payerSelect = document.getElementById("wallet_payer_id");
  const receiverSelect = document.getElementById("wallet_reciever_id");
  const swapButton = document.getElementById("wallet_swap_button");

  // ========= 1. Modal Bills Fetch Logic ==========
  if (modal) {
    modal.addEventListener("shown.bs.modal", function () {
      const paidById = document.getElementById("modal_paid_by_id")?.value;
      const receivedById = document.getElementById("modal_received_by_id")?.value;
      const billsContainer = document.getElementById("modal-bills-container");

      if (paidById && receivedById) {
        fetch(`/broker/payments/fetch_bills?paid_by_id=${paidById}&recieved_by_id=${receivedById}`, {
          headers: { "Accept": "text/html" }
        })
          .then(response => response.text())
          .then(html => {
            billsContainer.innerHTML = html;
            resetCheckboxesAndInputs();
            setupAllocationValidation();
          })
          .catch(() => {
            billsContainer.innerHTML = "<p class='text-danger'>Failed to load bills.</p>";
          });
      } else {
        billsContainer.innerHTML = "<p class='text-warning'>Payer or receiver not selected.</p>";
      }
    });
  }

  function resetCheckboxesAndInputs() {
    const checkboxes = document.querySelectorAll(".bill-checkbox");
    checkboxes.forEach(cb => {
      cb.checked = false;
      const input = cb.closest(".row").querySelector(".bill-allocation");
      if (input) {
        input.value = "";
        input.setAttribute("readonly", true);
      }
    });
  }

  // ========= 2. Allocation Validation =============
  function setupAllocationValidation() {
    const allocationInputs = document.querySelectorAll(".bill-allocation");
    const amountPaidInput = document.querySelector("input[name='payment[amount_paid]']");
    const submitBtn = document.querySelector("#paymentModal input[type='submit']");
    const checkboxes = document.querySelectorAll(".bill-checkbox");
    const warning = document.getElementById("allocation-warning") || createWarningDiv();

    function createWarningDiv() {
      const div = document.createElement("div");
      div.id = "allocation-warning";
      div.className = "text-danger mt-2";
      const container = amountPaidInput?.closest(".row")?.parentElement;
      container?.appendChild(div);
      return div;
    }

    function autoAllocate() {
      let remainingAmount = parseFloat(amountPaidInput?.value || 0);

      const bills = Array.from(checkboxes).map(cb => {
        const row = cb.closest(".row");
        const input = row.querySelector(".bill-allocation");
        const billMax = parseFloat(input.dataset.maxAmount) || 0;
        const billId = input.dataset.billId;
        return { cb, input, billId, billMax };
      });

      bills.forEach(bill => {
        if (bill.cb.checked && remainingAmount > 0) {
          bill.input.removeAttribute("readonly");
          const allocatable = Math.min(remainingAmount, bill.billMax);
          bill.input.value = allocatable.toFixed(2);
          remainingAmount -= allocatable;
        } else {
          bill.input.value = "";
          bill.input.setAttribute("readonly", true);
        }
      });

      validate();
    }

    function validate() {
      let totalAllocated = 0;
      let hasError = false;
      const paidAmount = parseFloat(amountPaidInput?.value || 0);

      allocationInputs.forEach(input => {
        const row = input.closest(".row");
        const checkbox = row.querySelector(".bill-checkbox");
        const billMax = parseFloat(input.dataset.maxAmount) || 0;
        const val = parseFloat(input.value) || 0;
        const billId = input.dataset.billId;
        const errorDiv = document.getElementById(`error-bill-${billId}`) || createErrorDiv(input, billId);

        if (checkbox?.checked) {
          totalAllocated += val;
          if (val > billMax) {
            input.classList.add("is-invalid");
            errorDiv.textContent = `Allocated amount cannot exceed remaining (${billMax}).`;
            hasError = true;
          } else {
            input.classList.remove("is-invalid");
            errorDiv.textContent = "";
          }
        } else {
          input.classList.remove("is-invalid");
          errorDiv.textContent = "";
        }
      });

      if (totalAllocated > paidAmount) {
        warning.textContent = `Total allocated (${totalAllocated.toFixed(2)}) exceeds paid amount (${paidAmount.toFixed(2)}).`;
        hasError = true;
      } else {
        warning.textContent = "";
      }

      if (submitBtn) submitBtn.disabled = hasError;
    }

    function createErrorDiv(input, billId) {
      const div = document.createElement("div");
      div.id = `error-bill-${billId}`;
      div.className = "invalid-feedback d-block";
      input.insertAdjacentElement("afterend", div);
      return div;
    }

    if (amountPaidInput) {
      amountPaidInput.addEventListener("input", autoAllocate);
    }

    checkboxes.forEach(cb => {
      cb.addEventListener("change", () => {
        const input = cb.closest(".row").querySelector(".bill-allocation");
        if (!cb.checked) {
          input.value = "";
          input.setAttribute("readonly", true);
        } else {
          input.removeAttribute("readonly");

          const paidAmount = parseFloat(amountPaidInput?.value || 0);
          let currentAllocated = 0;

          allocationInputs.forEach(i => {
            const row = i.closest(".row");
            const isChecked = row.querySelector(".bill-checkbox")?.checked;
            if (i !== input && isChecked) {
              currentAllocated += parseFloat(i.value) || 0;
            }
          });

          const remaining = Math.max(0, paidAmount - currentAllocated);
          const billMax = parseFloat(input.dataset.maxAmount) || 0;
          input.value = Math.min(billMax, remaining).toFixed(2);
        }

        validate();
      });
    });

    allocationInputs.forEach(input => {
      input.addEventListener("input", validate);
      input.addEventListener("keypress", function (e) {
        const allowedChars = "0123456789.";
        if (!allowedChars.includes(e.key) || (e.key === "." && input.value.includes("."))) {
          e.preventDefault();
        }
      });
    });
  }

  // ========= 3. View Type Selector ==========
  const select = document.getElementById("viewTypeSelect");
  if (select) {
    select.addEventListener("change", function () {
      const url = new URL(window.location.href);
      url.searchParams.set("view_type", this.value);
      window.location.href = url.toString();
    });
  }

  function loadReceivers(payerId, selectedReceiverId = null) {
    receiverSelect.innerHTML = '<option value="">Loading...</option>';
    receiverSelect.disabled = true;

    fetch(`/broker/wallets/possible_recievers?payer_id=${payerId}`)
      .then(response => response.json())
      .then(data => {
        receiverSelect.innerHTML = '<option value="">Select a Recieved By</option>';
        data.forEach(user => {
          const option = document.createElement("option");
          option.value = user.id;
          option.textContent = user.name;
          receiverSelect.appendChild(option);
        });

        if (selectedReceiverId) {
          receiverSelect.value = selectedReceiverId;
        }

        receiverSelect.disabled = false;
      })
      .catch(() => {
        receiverSelect.innerHTML = '<option value="">Select a Recieved By</option>';
        receiverSelect.disabled = false;
      });
  }

  if (payerSelect && receiverSelect) {
    payerSelect.addEventListener("change", function () {
      const payerId = this.value;
      loadReceivers(payerId);
    });
  }

  if (swapButton && payerSelect && receiverSelect) {
    swapButton.addEventListener("click", () => {
      const currentPayer = payerSelect.value;
      const currentReceiver = receiverSelect.value;

      payerSelect.value = currentReceiver;

      loadReceivers(currentReceiver, currentPayer);
    });
  }
});
